import type {
  IInfoPanelAction,
  IInfoPanelGroup,
  IInfoPanelItem,
  IInfoPanelItemData,
  IInfoPanelSearchOptions,
} from './types';
import type { BoxProps, InlineGridProps } from '@shopify/polaris';

import { GInfoPanelRightColumn } from './components/GInfoPanelRightColumn';
import { GInfoPanelLeftColumn } from './components/GInfoPanelLeftColumn';
import { useGInfoPanel } from './hooks/useGInfoPanel';
import { Box, InlineGrid } from '@shopify/polaris';

export interface GInfoPanelProps {
  items?: IInfoPanelItem[];
  groups?: IInfoPanelGroup[];
  selectedId?: string;
  selectedBackground?: BoxProps['background'];
  defaultInfo?: IInfoPanelItemData;
  minHeight?: string;
  columns?: InlineGridProps['columns'];
  width?: string;
  search?: IInfoPanelSearchOptions;
  searchEmpty?: string;
  leftAction?: IInfoPanelAction;
  leftSecondaryAction?: IInfoPanelAction;
  rightHidden?: boolean;
  rightAction?: IInfoPanelAction;
  rightSecondaryAction?: IInfoPanelAction;
  onSelect?: (id: string) => void;
}

export const GInfoPanel = ({
  items = [],
  groups = [],
  selectedId,
  selectedBackground,
  defaultInfo,
  minHeight,
  columns = ['oneThird', 'twoThirds'],
  width = '100%',
  search,
  searchEmpty,
  leftAction,
  leftSecondaryAction,
  rightHidden = false,
  rightAction,
  rightSecondaryAction,
  onSelect,
}: GInfoPanelProps) => {
  const {
    currentSelectedId,
    searchQuery,
    filteredItems,
    filteredGroups,
    currentInfo,
    hasNoResults,
    handleSelect,
    handleHover,
    handleSearchChange,
    handleClearSearch,
  } = useGInfoPanel({
    items,
    groups,
    selectedId,
    defaultInfo,
    search,
    onSelect,
  });

  return (
    <Box width={width}>
      <InlineGrid columns={columns}>
        <GInfoPanelLeftColumn
          items={filteredItems}
          groups={filteredGroups}
          selectedId={currentSelectedId}
          selectedBackground={selectedBackground}
          searchQuery={searchQuery}
          search={search}
          searchEmpty={searchEmpty}
          hasNoResults={hasNoResults}
          primaryAction={leftAction}
          secondaryAction={leftSecondaryAction}
          onSelect={handleSelect}
          onHover={handleHover}
          onSearchChange={handleSearchChange}
          onClearSearch={handleClearSearch}
        />

        {!rightHidden && (
          <GInfoPanelRightColumn
            info={currentInfo}
            minHeight={minHeight}
            primaryAction={rightAction}
            secondaryAction={rightSecondaryAction}
          />
        )}
      </InlineGrid>
    </Box>
  );
};
